
import Vue from 'vue'
import { RInput, RButton, GoogleSignInButton } from '@/components'
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('user')

export default Vue.extend({
  name: 'Login',
  components: {
    RInput,
    RButton,
    GoogleSignInButton,
  },
  data() {
    return {
      email: '',
      password: '',
    }
  },
  methods: {
    onLogin() {
      const { email, password } = this
      this.login({ email, password })
    },
    ...mapActions(['login', 'socialLogin']),
  },
  computed: {
    ...mapGetters(['loginRequest', 'socialRequest']),
    greeting(): string {
      return this.$route.meta?.success ? "Yay, you're all set!" : 'Hi there!'
    },
    subgreeting(): string {
      return this.$route.meta?.success
        ? 'You can now use your credentials to access your Cloud Workspace'
        : 'Log in to access your Cloud Workspace'
    },
  },
})
